(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["herrlichst-about-story-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-herrlichst-about]';

    const initRoot = (root) => {
      if (!root || root.dataset.haInit === 'true') return;
      root.dataset.haInit = 'true';

      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveals = root.querySelectorAll('[data-about-reveal]');

      if ('IntersectionObserver' in window && !prefersReduced) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        reveals.forEach((el) => io.observe(el));
      } else {
        reveals.forEach((el) => el.classList.add('is-visible'));
      }

      const motionStages = root.querySelectorAll('[data-about-stage]');
      if ('IntersectionObserver' in window && !prefersReduced) {
        const motionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.target.classList.toggle('is-motion-active', entry.isIntersecting));
        }, { threshold: 0, rootMargin: '30% 0px 30% 0px' });
        motionStages.forEach((stage) => motionObserver.observe(stage));
      } else {
        motionStages.forEach((stage) => stage.classList.add('is-motion-active'));
      }


      if (prefersReduced) return;

      const scrollContainer = root.closest('.page-wrapper');
      const scrollTarget = scrollContainer || window;
      let ticking = false;
      const update = () => {
        const rect = root.getBoundingClientRect();
        const viewportHeight = scrollContainer ? scrollContainer.clientHeight : window.innerHeight;
        const total = Math.max(1, rect.height - viewportHeight);
        const scrolled = Math.min(total, Math.max(0, -rect.top));
        root.style.setProperty('--ha-progress', (scrolled / total).toFixed(4));
        ticking = false;
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };
      update();
      scrollTarget.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    };

    const initWithin = (scope) => {
      if (scope.matches && scope.matches(selector)) initRoot(scope);
      if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(initRoot);
    };

    initWithin(document);
    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herrlichst-berater-v1"] && !Shopify.designMode) return;
  try {
    
  const herrlichstBeraterRoots = new Set();
  const herrlichstReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const herrlichstSlugify = (value) => {
    return value
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  const herrlichstUpdateTocHint = (root) => {
    const tocNav = root.querySelector(
      '[data-herrlichst-toc-nav]'
    );
    const tocScrollHint = root.querySelector(
      '[data-herrlichst-toc-scroll-hint]'
    );

    if (!tocNav || !tocScrollHint) {
      return;
    }

    const isDesktop =
      window.matchMedia('(min-width: 750px)').matches;

    const hasOverflow =
      tocNav.scrollHeight > tocNav.clientHeight + 4;

    const isAtBottom =
      tocNav.scrollTop + tocNav.clientHeight >=
      tocNav.scrollHeight - 4;

    tocScrollHint.hidden =
      !isDesktop ||
      !hasOverflow ||
      isAtBottom;
  };

  const herrlichstInitToc = (root) => {
    if (root.dataset.tocInitialized === 'true') {
      herrlichstUpdateTocHint(root);
      return;
    }

    const content = root.querySelector(
      '[data-herrlichst-content]'
    );
    const toc = root.querySelector(
      '[data-herrlichst-toc]'
    );
    const tocList = root.querySelector(
      '[data-herrlichst-toc-list]'
    );
    const tocNav = root.querySelector(
      '[data-herrlichst-toc-nav]'
    );

    if (!content || !toc || !tocList) {
      return;
    }

    const headings = Array.from(
      content.querySelectorAll('h2')
    );

    if (headings.length === 0) {
      return;
    }

    root.dataset.tocInitialized = 'true';

    const usedIds = new Set();

    headings.forEach((heading, index) => {
      const headingText =
        heading.textContent.trim();

      if (!headingText) {
        return;
      }

      let baseId =
        heading.id ||
        herrlichstSlugify(headingText);

      if (!baseId) {
        baseId = `abschnitt-${index + 1}`;
      }

      let uniqueId = baseId;
      let duplicateIndex = 2;

      while (usedIds.has(uniqueId)) {
        uniqueId =
          `${baseId}-${duplicateIndex}`;
        duplicateIndex += 1;
      }

      usedIds.add(uniqueId);
      heading.id = uniqueId;

      const item =
        document.createElement('li');
      item.className =
        'herrlichst-berater__toc-item';

      const link =
        document.createElement('a');
      link.className =
        'herrlichst-berater__toc-link';
      link.href = `#${uniqueId}`;
      link.textContent = headingText;

      item.appendChild(link);
      tocList.appendChild(item);
    });

    if (tocList.children.length > 0) {
      toc.hidden = false;
      const tocToggle = toc.querySelector(
        '[data-herrlichst-toc-toggle]'
      );
      if (
        tocToggle &&
        tocToggle.dataset.initialized !== 'true'
      ) {
        tocToggle.dataset.initialized = 'true';
        const setMobileTocState = (isOpen) => {
          toc.dataset.mobileOpen = String(isOpen);
          tocToggle.setAttribute(
            'aria-expanded',
            String(isOpen)
          );
        };
        setMobileTocState(false);
        tocToggle.addEventListener('click', () => {
          setMobileTocState(
            toc.dataset.mobileOpen !== 'true'
          );
        });
        toc
          .querySelectorAll('.herrlichst-berater__toc-link')
          .forEach((link) => {
            link.addEventListener('click', () => {
              if (
                window.matchMedia('(max-width: 749px)').matches
              ) {
                setMobileTocState(false);
              }
            });
          });
      }
    }

    if (
      tocNav &&
      tocNav.dataset.hintListenerInitialized !==
        'true'
    ) {
      tocNav.dataset.hintListenerInitialized =
        'true';

      tocNav.addEventListener(
        'scroll',
        () => herrlichstUpdateTocHint(root),
        { passive: true }
      );
    }

    window.requestAnimationFrame(
      () => herrlichstUpdateTocHint(root)
    );
  };

  const herrlichstUpdateBlobs = (root) => {
    if (herrlichstReducedMotion.matches) {
      return;
    }

    const body = root.querySelector(
      '.herrlichst-berater__body'
    );

    if (!body) {
      return;
    }

    const rect =
      body.getBoundingClientRect();

    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      1;

    /* Nur in bzw. nahe am Viewport neu berechnen. */
    const viewportBuffer = viewportHeight * 0.75;

    if (
      rect.bottom < -viewportBuffer ||
      rect.top > viewportHeight + viewportBuffer
    ) {
      return;
    }

    const centerOffset =
      (rect.top + rect.height * 0.5) -
      viewportHeight * 0.5;

    const normalized =
      Math.max(
        -1,
        Math.min(
          1,
          centerOffset /
            Math.max(viewportHeight, 1)
        )
      );

    root.style.setProperty(
      '--hb-scroll-shift-left',
      `${(normalized * -72).toFixed(1)}px`
    );

    root.style.setProperty(
      '--hb-scroll-shift-right',
      `${(normalized * 86).toFixed(1)}px`
    );

    root.style.setProperty(
      '--hb-scroll-shift-left-secondary',
      `${(normalized * 42).toFixed(1)}px`
    );

    root.style.setProperty(
      '--hb-scroll-shift-right-secondary',
      `${(normalized * -48).toFixed(1)}px`
    );
  };

  const herrlichstInitBerater = (root) => {
    if (!root) {
      return;
    }

    herrlichstBeraterRoots.add(root);
    herrlichstInitToc(root);
    herrlichstUpdateBlobs(root);
  };

  const herrlichstInitAllBerater = (scope) => {
    if (
      scope instanceof Element &&
      scope.matches('.herrlichst-berater')
    ) {
      herrlichstInitBerater(scope);
    }

    scope
      .querySelectorAll?.('.herrlichst-berater')
      .forEach(herrlichstInitBerater);
  };

  let herrlichstViewportTicking = false;

  const herrlichstUpdateViewport = () => {
    herrlichstViewportTicking = false;

    herrlichstBeraterRoots.forEach((root) => {
      if (!root.isConnected) {
        herrlichstBeraterRoots.delete(root);
        return;
      }

      herrlichstUpdateBlobs(root);
    });
  };

  const herrlichstRequestViewportUpdate = () => {
    if (herrlichstViewportTicking) {
      return;
    }

    herrlichstViewportTicking = true;

    window.requestAnimationFrame(
      herrlichstUpdateViewport
    );
  };

  herrlichstInitAllBerater(document);

  window.addEventListener(
    'scroll',
    herrlichstRequestViewportUpdate,
    { passive: true }
  );

  document.querySelector('.page-wrapper')?.addEventListener(
    'scroll',
    herrlichstRequestViewportUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    () => {
      herrlichstRequestViewportUpdate();

      herrlichstBeraterRoots.forEach((root) => {
        if (root.isConnected) {
          herrlichstUpdateTocHint(root);
        }
      });
    },
    { passive: true }
  );

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      herrlichstInitAllBerater(event.target);
      herrlichstRequestViewportUpdate();

      window.requestAnimationFrame(() => {
        event.target
          .querySelectorAll?.('.herrlichst-berater')
          .forEach(herrlichstUpdateTocHint);
      });
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herrlichst-home-berater-shuffle"] && !Shopify.designMode) return;
  try {
    

  (() => {

    if (customElements.get('herrlichst-home-berater')) {
      return;
    }


    class HerrlichstHomeBerater extends HTMLElement {

      connectedCallback() {

        if (this.initialized) {
          return;
        }

        this.initialized = true;

        this.grid = this.querySelector('[data-adviser-grid]');
        this.dataNode = this.querySelector('[data-adviser-pool]');
        this.shuffleButton = this.querySelector('[data-shuffle-button]');
        this.shuffleStatus = this.querySelector('[data-shuffle-status]');
        this.mobileStatus = this.querySelector('[data-mobile-status]');
        this.progress = this.querySelector('[data-mobile-progress]');

        if (!this.grid || !this.dataNode) {
          return;
        }


        try {

          this.pool = JSON.parse(this.dataNode.textContent || '[]');

        } catch (error) {

          this.pool = [];

        }


        if (!Array.isArray(this.pool) || this.pool.length === 0) {
          return;
        }


        this.currentIds = [];
        this.remaining = this.shuffleArray([...this.pool]);

        this.renderNextSet(false);

        this.classList.add('is-enhanced');

        if (this.shuffleButton) {

          if (this.pool.length <= 3) {

            this.shuffleButton.hidden = true;

          } else {

            this.shuffleButton.addEventListener(
              'click',
              () => this.handleShuffle()
            );

          }

        }


        this.bindMobileProgress();

      }


      shuffleArray(items) {

        for (let index = items.length - 1; index > 0; index -= 1) {

          const randomIndex = Math.floor(
            Math.random() * (index + 1)
          );

          [
            items[index],
            items[randomIndex]
          ] = [
            items[randomIndex],
            items[index]
          ];

        }

        return items;

      }


      refillQueue() {

        const candidates = this.pool.filter(
          item => !this.currentIds.includes(
            String(item.id)
          )
        );

        const shuffledCandidates = this.shuffleArray(
          [...candidates]
        );

        if (shuffledCandidates.length >= 3) {

          this.remaining = shuffledCandidates;

          return;
        }


        const supplemental = this.shuffleArray(
          this.pool.filter(
            item => !shuffledCandidates.some(
              candidate => String(candidate.id) === String(item.id)
            )
          )
        );


        this.remaining = [
          ...shuffledCandidates,
          ...supplemental
        ];

      }


      nextItems() {

        if (this.pool.length <= 3) {
          return [...this.pool];
        }


        if (this.remaining.length < 3) {
          this.refillQueue();
        }


        const next = this.remaining.splice(0, 3);

        this.currentIds = next.map(
          item => String(item.id)
        );

        return next;

      }


      renderNextSet(animate = true) {

        const items = this.nextItems();

        if (!items.length) {
          return;
        }


        const reducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;


        const commit = () => {

          this.grid.replaceChildren(
            ...items.map(
              (item, index) => this.createSlot(item, index)
            )
          );

          this.grid.scrollTo({
            left: 0,
            behavior: 'auto'
          });

          this.grid.setAttribute('aria-busy', 'false');

          this.updateProgress(0);

          requestAnimationFrame(
            () => this.classList.remove('is-changing')
          );

        };


        this.grid.setAttribute('aria-busy', 'true');


        if (!animate || reducedMotion) {

          commit();

          return;
        }


        this.classList.add('is-changing');

        window.setTimeout(
          commit,
          180
        );

      }


      handleShuffle() {

        if (!this.shuffleButton) {
          return;
        }


        this.shuffleButton.classList.remove('is-spinning');

        void this.shuffleButton.offsetWidth;

        this.shuffleButton.classList.add('is-spinning');

        this.renderNextSet(true);


        if (this.shuffleStatus) {

          this.shuffleStatus.textContent =
            'Drei neue Herrlichst Berater wurden geladen.';

        }


        window.setTimeout(
          () => this.shuffleButton?.classList.remove('is-spinning'),
          560
        );

      }


      createSlot(item, index) {

        const slot = document.createElement('div');

        slot.className = 'herrlichst-home-berater__slot';

        slot.style.setProperty(
          '--hhb-card-index',
          String(index)
        );


        const article = document.createElement('article');

        article.className = 'herrlichst-home-berater__card';

        const titleId =
          `HerrlichstHomeBeraterCard-${this.id}-${item.id}`;

        article.setAttribute(
          'aria-labelledby',
          titleId
        );


        const link = document.createElement('a');

        link.className = 'herrlichst-home-berater__card-link';
        link.href = item.url;
        link.setAttribute(
          'aria-label',
          `Zum Berater: ${item.title}`
        );


        const media = document.createElement('div');

        media.className = 'herrlichst-home-berater__media';


        if (
          this.dataset.showBadge === 'true' &&
          item.badge
        ) {

          const badge = document.createElement('span');

          badge.className = 'herrlichst-home-berater__badge';
          badge.textContent = item.badge;

          media.append(badge);

        }


        if (item.image) {

          const image = document.createElement('img');

          image.className = 'herrlichst-home-berater__image';

          image.src = item.image.medium || item.image.large;

          image.srcset = [
            `${item.image.small} 450w`,
            `${item.image.medium} 700w`,
            `${item.image.large} 1000w`
          ].join(', ');

          image.sizes =
            '(min-width: 990px) 33vw, (min-width: 750px) 50vw, 84vw';

          image.loading = 'lazy';
          image.decoding = 'async';
          image.alt = item.image_alt || item.title || '';

          media.append(image);

        } else {

          const placeholder = document.createElement('div');

          placeholder.className =
            'herrlichst-home-berater__placeholder';


          const dot = document.createElement('span');

          dot.className =
            'herrlichst-home-berater__placeholder-dot';


          const placeholderText = document.createElement('span');

          placeholderText.className =
            'herrlichst-home-berater__placeholder-text';

          placeholderText.textContent = 'Herrlichst';


          placeholder.append(
            dot,
            placeholderText
          );

          media.append(placeholder);

        }


        const content = document.createElement('div');

        content.className = 'herrlichst-home-berater__content';


        if (
          this.dataset.showCardEyebrow === 'true' &&
          this.dataset.cardEyebrow
        ) {

          const eyebrow = document.createElement('p');

          eyebrow.className =
            'herrlichst-home-berater__card-eyebrow';

          eyebrow.textContent =
            this.dataset.cardEyebrow;

          content.append(eyebrow);

        }


        const heading = document.createElement('h3');

        heading.className =
          'herrlichst-home-berater__card-title';

        heading.id = titleId;
        heading.textContent = item.title || '';

        content.append(heading);


        if (item.excerpt) {

          const excerpt = document.createElement('p');

          excerpt.className =
            'herrlichst-home-berater__excerpt';

          excerpt.textContent = item.excerpt;

          content.append(excerpt);

        }


        if (this.dataset.ctaLabel) {

          const cta = document.createElement('span');

          cta.className =
            'herrlichst-home-berater__card-cta';


          const ctaText = document.createElement('span');

          ctaText.textContent =
            this.dataset.ctaLabel;


          const arrow = document.createElement('span');

          arrow.className =
            'herrlichst-home-berater__arrow';

          arrow.setAttribute(
            'aria-hidden',
            'true'
          );

          arrow.textContent = '→';


          cta.append(
            ctaText,
            arrow
          );

          content.append(cta);

        }


        link.append(
          media,
          content
        );

        article.append(link);
        slot.append(article);

        return slot;

      }


      bindMobileProgress() {

        if (!this.progress) {
          return;
        }


        let ticking = false;


        this.grid.addEventListener(
          'scroll',
          () => {

            if (ticking) {
              return;
            }

            ticking = true;


            requestAnimationFrame(
              () => {

                const slots = [
                  ...this.grid.querySelectorAll(
                    '.herrlichst-home-berater__slot'
                  )
                ];


                if (!slots.length) {

                  ticking = false;

                  return;

                }


                const gridRect =
                  this.grid.getBoundingClientRect();

                const gridCenter =
                  gridRect.left + (gridRect.width / 2);


                let closestIndex = 0;
                let closestDistance = Infinity;


                slots.forEach(
                  (slot, index) => {

                    const rect =
                      slot.getBoundingClientRect();

                    const center =
                      rect.left + (rect.width / 2);

                    const distance =
                      Math.abs(center - gridCenter);


                    if (distance < closestDistance) {

                      closestDistance = distance;
                      closestIndex = index;

                    }

                  }
                );


                this.updateProgress(closestIndex);

                ticking = false;

              }
            );

          },
          {
            passive: true
          }
        );

      }


      updateProgress(activeIndex) {

        if (!this.progress) {
          return;
        }


        const dots = [
          ...this.progress.children
        ];


        dots.forEach(
          (dot, index) => {

            dot.classList.toggle(
              'is-active',
              index === activeIndex
            );

          }
        );


        if (this.mobileStatus) {

          const total = Math.min(
            3,
            this.pool.length
          );

          this.mobileStatus.textContent =
            `Berater ${activeIndex + 1} von ${total}`;

        }

      }

    }


    customElements.define(
      'herrlichst-home-berater',
      HerrlichstHomeBerater
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herrlichst-slot-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '[data-herrlichst-slot]';
    const PRODUCT_CANDIDATE_LIMIT = 6;

    const shuffle = (items) => {
      const copy = [...items];

      for (let index = copy.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));

        [copy[index], copy[randomIndex]] = [
          copy[randomIndex],
          copy[index]
        ];
      }

      return copy;
    };

    const createFallback = () => {
      const fallback = document.createElement('span');
      fallback.className = 'herrlichst-slot__fallback';
      fallback.setAttribute('aria-hidden', 'true');

      for (let index = 0; index < 3; index += 1) {
        fallback.append(document.createElement('span'));
      }

      return fallback;
    };

    const createItem = (option, eager = false) => {
      const link = document.createElement('a');
      link.className = 'herrlichst-slot__item';
      link.href = option.url;

      const imageWrap = document.createElement('span');
      imageWrap.className = 'herrlichst-slot__image-wrap';

      if (option.image) {
        const image = document.createElement('img');

        image.className = 'herrlichst-slot__image';
        image.src = option.image;
        image.alt = option.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.fetchPriority = 'low';

        imageWrap.append(image);
      } else {
        imageWrap.append(createFallback());
      }

      const title = document.createElement('span');
      title.className = 'herrlichst-slot__item-title';
      title.textContent = option.title;

      const cta = document.createElement('span');
      cta.className = 'herrlichst-slot__item-cta';

      const ctaText = document.createElement('span');
      ctaText.textContent = 'Kategorie ansehen';

      const arrow = document.createElement('span');
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';

      cta.append(ctaText, arrow);
      link.append(imageWrap, title, cta);

      return link;
    };

    const createCountdownResult = (value) => {
      const card = document.createElement('div');
      card.className =
        'herrlichst-slot__result-card herrlichst-slot__result-card--countdown';

      const kicker = document.createElement('span');
      kicker.className = 'herrlichst-slot__countdown-kicker';
      kicker.textContent = 'Da braut sich was zusammen';

      const number = document.createElement('strong');
      number.className = 'herrlichst-slot__countdown-number';
      number.textContent = String(value);

      const copy = document.createElement('span');
      copy.className = 'herrlichst-slot__countdown-copy';
      copy.textContent = 'Jackpot – wir ziehen gerade deinen Herrlichst-Treffer.';

      card.append(kicker, number, copy);
      return card;
    };

    const createLoadingResult = () => {
      const card = document.createElement('div');
      card.className =
        'herrlichst-slot__result-card herrlichst-slot__result-card--loading';

      const loader = document.createElement('span');
      loader.className = 'herrlichst-slot__result-loader';
      loader.setAttribute('aria-hidden', 'true');

      const title = document.createElement('p');
      title.className = 'herrlichst-slot__result-title';
      title.textContent = 'Treffer!';

      const copy = document.createElement('p');
      copy.className = 'herrlichst-slot__result-copy';
      copy.textContent = 'Wir ziehen gerade dein Herrlichst-Produkt …';

      card.append(loader, title, copy);
      return card;
    };

    const createProductResult = (
      product,
      collection,
      fallbackUrl
    ) => {
      const link = document.createElement('a');
      link.className = 'herrlichst-slot__result-product';
      link.href = product.url || fallbackUrl;

      const imageWrap = document.createElement('span');
      imageWrap.className =
        'herrlichst-slot__result-product-image-wrap';

      if (product.featured_image) {
        const visual = document.createElement('span');
        visual.className = 'herrlichst-slot__result-product-visual';
        visual.setAttribute('role', 'img');
        visual.setAttribute('aria-label', product.title || 'Herrlichst Produkt');
        const productImageUrl = String(product.featured_image).replace(/"/g, '\\"');
        visual.style.backgroundImage = `url("${productImageUrl}")`;
        imageWrap.append(visual);
      } else {
        imageWrap.append(createFallback());
      }

      const content = document.createElement('span');
      content.className = 'herrlichst-slot__result-product-copy';

      const badge = document.createElement('span');
      badge.className = 'herrlichst-slot__result-product-badge';
      badge.textContent = 'Dein Treffer';

      const kicker = document.createElement('span');
      kicker.className = 'herrlichst-slot__result-product-kicker';
      kicker.textContent = `Aus ${collection.title}`;

      const cta = document.createElement('span');
      cta.className = 'herrlichst-slot__result-product-cta';
      cta.textContent = 'Produkt ansehen →';

      content.append(badge, kicker, cta);
      link.append(imageWrap, content);

      return link;
    };

    const createFallbackResult = (collection) => {
      const card = document.createElement('div');
      card.className = 'herrlichst-slot__result-card';

      const pill = document.createElement('span');
      pill.className = 'herrlichst-slot__result-pill';
      pill.textContent = 'Treffer';

      const title = document.createElement('p');
      title.className = 'herrlichst-slot__result-title';
      title.textContent = collection.title;

      const copy = document.createElement('p');
      copy.className = 'herrlichst-slot__result-copy';
      copy.textContent =
        'Dein Produkt lässt sich gerade nicht laden – die Kategorie wartet aber schon auf dich.';

      const link = document.createElement('a');
      link.className = 'herrlichst-slot__result-fallback-link';
      link.href = collection.url;
      link.textContent = 'Kategorie ansehen →';

      card.append(pill, title, copy, link);
      return card;
    };

    const createSpinItem = (option) => {
      const item = document.createElement('div');

      item.className = 'herrlichst-slot__spin-item';
      item.setAttribute('aria-hidden', 'true');

      const imageWrap = document.createElement('span');
      imageWrap.className = 'herrlichst-slot__spin-image-wrap';

      if (option.image_small) {
        const image = document.createElement('img');

        image.className = 'herrlichst-slot__spin-image';
        image.src = option.image_small;
        image.alt = '';
        image.loading = 'eager';
        image.decoding = 'async';
        image.fetchPriority = 'low';

        imageWrap.append(image);
      } else {
        imageWrap.append(createFallback());
      }

      const title = document.createElement('span');
      title.className = 'herrlichst-slot__spin-title';
      title.textContent = option.title;

      item.append(imageWrap, title);

      return item;
    };

    const parseOptions = (root) => {
      const dataElement = root.querySelector('[data-slot-data]');

      if (!dataElement) return [];

      try {
        const parsed = JSON.parse(
          dataElement.textContent || '[]'
        );

        return parsed
          .filter(
            (option) =>
              option &&
              typeof option.title === 'string' &&
              option.title.trim() &&
              typeof option.url === 'string' &&
              option.url.trim()
          )
          .map((option) => ({
            ...option,
            product_handles: Array.isArray(option.product_handles)
              ? option.product_handles
                  .filter(
                    (handle) =>
                      typeof handle === 'string' &&
                      handle.trim()
                  )
                  .slice(0, PRODUCT_CANDIDATE_LIMIT)
              : []
          }));
      } catch (error) {
        console.warn(
          'Herrlichst Slot: Kategoriedaten konnten nicht gelesen werden.'
        );

        return [];
      }
    };

    const preloadFinalTargets = (targets) => {
      const uniqueTargets = [
        ...new Map(
          targets.map((target) => [target.url, target])
        ).values()
      ];

      uniqueTargets.forEach((target) => {
        if (!target.image) return;

        const image = new Image();

        image.decoding = 'async';
        image.fetchPriority = 'low';
        image.src = target.image;
      });
    };

    const init = (root) => {
      if (
        !root ||
        root.dataset.slotInitialized === 'true'
      ) {
        return;
      }

      root.dataset.slotInitialized = 'true';

      const machine =
        root.querySelector('[data-slot-machine]');

      const button =
        root.querySelector('[data-slot-spin]');

      const reels = [
        ...root.querySelectorAll('[data-slot-reel]')
      ];

      const announcer =
        root.querySelector('[data-slot-announcer]');

      const resultStage =
        root.querySelector('[data-slot-result-stage]');

      const statusBubble =
        root.querySelector('[data-slot-status-bubble]');

      const statusText =
        root.querySelector('[data-slot-status-text]');

      const options = parseOptions(root);

      if (
        !machine ||
        !button ||
        !resultStage ||
        reels.length !== 3 ||
        !options.length
      ) {
        return;
      }

      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const saveData = Boolean(
        navigator.connection &&
        navigator.connection.saveData
      );

      const productCache = new Map();

      let spinning = false;
      let previousUrls = [];
      let previousJackpotUrl = '';
      let previousProductHandle = '';
      let userSpinCount = 0;
      let resultRunId = 0;

      const defaultResultNodes =
        [...resultStage.childNodes].map((node) => node.cloneNode(true));

      const renderResult = (node) => {
        if (!node) return;
        resultStage.replaceChildren(node);
      };

      const showDefaultResult = () => {
        resultRunId += 1;
        resultStage.replaceChildren(
          ...defaultResultNodes.map((node) => node.cloneNode(true))
        );
      };

      const setStatusBubble = (mode, message) => {
        if (!statusBubble || !statusText) return;

        statusText.textContent = message || '';
        statusBubble.hidden = !message;
        statusBubble.classList.remove('is-miss', 'is-jackpot');

        if (message && mode) {
          statusBubble.classList.add(`is-${mode}`);
        }
      };

      const showMissResult = () => {
        showDefaultResult();
        setStatusBubble('miss', 'Kein Treffer · Nochmal drehen');
      };

      const startCountdown = () => {
        const runId = ++resultRunId;
        const stepDuration =
          reduceMotion || saveData ? 320 : 760;
        const steps = [3, 2];

        return new Promise((resolve) => {
          let stepIndex = 0;

          const renderStep = () => {
            if (runId !== resultRunId) {
              resolve(false);
              return;
            }

            renderResult(createCountdownResult(steps[stepIndex]));

            if (stepIndex >= steps.length - 1) {
              window.setTimeout(() => resolve(true), stepDuration);
              return;
            }

            stepIndex += 1;
            window.setTimeout(renderStep, stepDuration);
          };

          renderStep();
        });
      };

      const pickTargets = () => {
        if (options.length <= 3) {
          const selected = shuffle(options);

          return Array.from(
            { length: 3 },
            (_, index) =>
              selected[index % selected.length]
          );
        }

        let selected =
          shuffle(options).slice(0, 3);

        let tries = 0;

        const previousKey =
          [...previousUrls].sort().join('|');

        while (
          tries < 8 &&
          selected
            .map((item) => item.url)
            .sort()
            .join('|') === previousKey
        ) {
          selected =
            shuffle(options).slice(0, 3);

          tries += 1;
        }

        return selected;
      };

      const pickJackpotTarget = () => {
        const withProducts = options.filter(
          (option) => option.product_handles.length
        );

        const pool = withProducts.length
          ? withProducts
          : options;

        if (pool.length === 1) {
          return pool[0];
        }

        let target =
          pool[Math.floor(Math.random() * pool.length)];

        let tries = 0;

        while (
          tries < 8 &&
          target.url === previousJackpotUrl
        ) {
          target =
            pool[Math.floor(Math.random() * pool.length)];
          tries += 1;
        }

        return target;
      };

      const pickProductHandle = (option) => {
        const handles = option?.product_handles || [];

        if (!handles.length) return '';
        if (handles.length === 1) return handles[0];

        const alternatives = handles.filter(
          (handle) => handle !== previousProductHandle
        );

        const pool = alternatives.length
          ? alternatives
          : handles;

        return pool[
          Math.floor(Math.random() * pool.length)
        ];
      };

      const fetchProduct = async (handle) => {
        if (!handle) return null;

        if (productCache.has(handle)) {
          return productCache.get(handle);
        }

        const routeRoot =
          window.Shopify?.routes?.root || '/';

        const productUrl =
          `${routeRoot}products/${encodeURIComponent(handle)}`;

        const request = fetch(
          `${productUrl}.js`,
          {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          }
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `Product request failed: ${response.status}`
              );
            }

            return response.json();
          })
          .then((product) => ({
            ...product,
            url: productUrl
          }));

        productCache.set(handle, request);

        try {
          return await request;
        } catch (error) {
          productCache.delete(handle);

          console.warn(
            'Herrlichst Slot: Gewinner-Produkt konnte nicht geladen werden.'
          );

          return null;
        }
      };

      const clearWinState = () => {
        machine.classList.remove('is-jackpot-hit');
        setStatusBubble('', '');
      };

      const setReelBusy = (reel, busy) => {
        reel.classList.toggle(
          'is-spinning',
          busy
        );

        reel.setAttribute(
          'aria-busy',
          busy ? 'true' : 'false'
        );
      };

      const settle = (
        reel,
        target,
        eager = false
      ) => {
        const track =
          reel.querySelector('[data-slot-track]');

        if (!track || !target) return;

        track.classList.remove('is-spinning');

        track.style.transition = 'none';
        track.style.transform = 'translateY(0)';

        setReelBusy(reel, false);

        track.replaceChildren(
          createItem(target, eager)
        );

        reel.classList.add('is-stopping');

        window.setTimeout(() => {
          reel.classList.remove('is-stopping');
        }, 560);
      };

      const completeSpin = () => {
        spinning = false;
        machine.classList.remove('is-spinning');
        machine.removeAttribute('aria-busy');

        button.disabled =
          options.length < 2;
      };

      const revealProduct = (
        product,
        winningOption,
        productHandle
      ) => {
        if (!product || !winningOption) {
          completeSpin();
          return;
        }

        const routeRoot =
          window.Shopify?.routes?.root || '/';

        const fallbackUrl =
          `${routeRoot}products/${encodeURIComponent(productHandle)}`;

        renderResult(
          createProductResult(
            product,
            winningOption,
            fallbackUrl
          )
        );

        previousProductHandle = productHandle;

        if (announcer) {
          announcer.textContent =
            `Dein Herrlichst Treffer aus ${winningOption.title}: ${product.title}.`;
        }

        completeSpin();
      };

      const finishSpin = async (
        targets,
        {
          jackpot = false,
          automatic = false,
          winningOption = null,
          productHandle = '',
          productPromise = null
        } = {}
      ) => {
        previousUrls =
          targets.map((item) => item.url);

        machine.classList.remove('is-spinning');
        machine.removeAttribute('aria-busy');

        if (!jackpot || !winningOption) {
          if (!automatic) {
            showMissResult();
          }

          if (announcer) {
            announcer.textContent = automatic
              ? `Deine Kategorien: ${targets
                  .map((item) => item.title)
                  .join(', ')}.`
              : `Kein Treffer. Deine Kategorien: ${targets
                  .map((item) => item.title)
                  .join(', ')}.`;
          }

          completeSpin();
          return;
        }

        previousJackpotUrl = winningOption.url;
        machine.classList.add('is-jackpot-hit');

        setStatusBubble('jackpot', `Jackpot · 3 × ${winningOption.title}`);

        if (announcer) {
          announcer.textContent =
            `Treffer: dreimal ${winningOption.title}. Dein Produkt wird ausgewählt.`;
        }

        if (!automatic) {
          await startCountdown();
        }

        let product = null;

        if (productPromise) {
          product = await Promise.race([
            productPromise,
            new Promise((resolve) => {
              window.setTimeout(
                () => resolve('__pending__'),
                120
              );
            })
          ]);

          if (product === '__pending__') {
            renderResult(createLoadingResult());

            product = await Promise.race([
              productPromise,
              new Promise((resolve) => {
                window.setTimeout(
                  () => resolve(null),
                  2800
                );
              })
            ]);
          }
        }

        machine.classList.remove('is-jackpot-hit');


        if (!product) {
          renderResult(
            createFallbackResult(winningOption)
          );
          completeSpin();
          return;
        }

        revealProduct(
          product,
          winningOption,
          productHandle
        );
      };

      const spin = ({
        animate = true,
        automatic = false,
        jackpot = false
      } = {}) => {
        if (spinning) return;

        spinning = true;

        if (!automatic) {
          clearWinState();
        }

        showDefaultResult();

        const winningOption = jackpot
          ? pickJackpotTarget()
          : null;

        const targets = winningOption
          ? [winningOption, winningOption, winningOption]
          : pickTargets();

        const productHandle = winningOption
          ? pickProductHandle(winningOption)
          : '';

        const productPromise = productHandle
          ? fetchProduct(productHandle)
          : null;

        if (animate && !reduceMotion && !saveData) {
          preloadFinalTargets(targets);
        }

        button.disabled = true;

        machine.classList.add('is-spinning');
        machine.setAttribute(
          'aria-busy',
          'true'
        );

        if (
          announcer &&
          !automatic
        ) {
          announcer.textContent = jackpot
            ? 'Die Walzen laufen. Vielleicht ist heute dein Glückstag.'
            : 'Die Kategorien werden neu gemischt.';
        }

        if (
          !animate ||
          reduceMotion ||
          saveData
        ) {
          reels.forEach(
            (reel, index) => {
              settle(
                reel,
                targets[index],
                true
              );
            }
          );

          window.setTimeout(
            () => finishSpin(
              targets,
              {
                jackpot,
                automatic,
                winningOption,
                productHandle,
                productPromise
              }
            ),
            100
          );

          return;
        }

        const baseDuration = jackpot ? 860 : 2200;
        const stagger = jackpot ? 180 : 550;

        reels.forEach(
          (reel, reelIndex) => {
            const track =
              reel.querySelector(
                '[data-slot-track]'
              );

            if (!track) return;

            const target =
              targets[reelIndex];

            const sequenceLength =
              8 + (reelIndex * 2);

            const sequence = [];

            for (
              let index = 0;
              index < sequenceLength - 1;
              index += 1
            ) {
              sequence.push(
                options[
                  Math.floor(
                    Math.random() *
                    options.length
                  )
                ]
              );
            }

            sequence.push(target);

            setReelBusy(reel, true);

            track.classList.add(
              'is-spinning'
            );

            track.style.transition =
              'none';

            track.style.transform =
              'translateY(0)';

            track.replaceChildren(
              ...sequence.map(
                (item) =>
                  createSpinItem(item)
              )
            );

            const duration =
              baseDuration +
              (reelIndex * stagger);

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                track.style.transition =
                  `transform ${duration}ms ` +
                  'cubic-bezier(0.11, 0.72, 0.14, 1)';

                track.style.transform =
                  `translateY(-${
                    (sequence.length - 1) * 100
                  }%)`;
              });
            });

            window.setTimeout(() => {
              settle(
                reel,
                target,
                false
              );
            }, duration + 45);
          }
        );

        const totalDuration =
          baseDuration +
          ((reels.length - 1) * stagger) +
          620;

        window.setTimeout(
          () => finishSpin(
            targets,
            {
              jackpot,
              automatic,
              winningOption,
              productHandle,
              productPromise
            }
          ),
          totalDuration
        );
      };

      button.addEventListener(
        'click',
        () => {
          userSpinCount += 1;

          spin({
            animate: true,
            automatic: false,
            jackpot: userSpinCount % 2 === 0
          });
        }
      );

      /*
        Balanced Auto-Start:
        - bleibt rein visuell und zählt NICHT als User-Spin
        - sichtbar: echter Spin
        - weiter unten: nur fertige Zufallsergebnisse setzen
      */
      window.setTimeout(() => {
        const rect =
          root.getBoundingClientRect();

        const nearViewport =
          rect.top <
            window.innerHeight + 120 &&
          rect.bottom > -120;

        spin({
          animate: nearViewport,
          automatic: true,
          jackpot: false
        });
      }, 520);
    };

    const initAll = (
      scope = document
    ) => {
      scope
        .querySelectorAll(
          ROOT_SELECTOR
        )
        .forEach(init);
    };

    if (
      document.readyState ===
      'loading'
    ) {
      document.addEventListener(
        'DOMContentLoaded',
        () => initAll(),
        { once: true }
      );
    } else {
      initAll();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) =>
        initAll(event.target)
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
